(function(){
  const target =
    document.querySelector('#shopify-section-related-products .title') ||
    document.querySelector('#shopify-section-related-products h2') ||
    document.querySelector('.related-products .title') ||
    document.querySelector('.related-products h2');

  if(!target) return;

  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.classList.add('lfm-in');
        io.disconnect();
      }
    });
  }, { threshold: 0.2 });

  io.observe(target);
})();